import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, InputAdornment, TextField } from '@mui/material';
import CurrencyFormatField from 'components/common/CurrencyFormatField';
import AutoSearch from 'components/common/AutoSearch';
import { ModalActionProps } from 'models/AutoModals';
import Api from 'utils/api';


type TopUpCreationDialogProps = {} & ModalActionProps<{
    companyId: number,
    amount: number,
}>

const TopUpCreationDialog = ({onFinish}: TopUpCreationDialogProps) => {
    const [companyId, setCompanyId] = useState<number>();
    const [amount, setAmount] = useState<number>();
    const {t} = useTranslation();

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (amount && companyId)
            onFinish({amount, companyId});
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <AutoSearch
                    search={Api.company.search}
                    onChange={val => val && setCompanyId( val.id)}
                    margin="normal"
                    label={t('shipper')}
                    keepValue
                />

                <TextField
                    id="amount"
                    name="amount"
                    label={t('amount')}
                    fullWidth
                    required
                    value={amount}
                    onChange={e => setAmount(Number(e.target.value))}
                    InputProps={{
                        inputComponent: CurrencyFormatField as any,
                        startAdornment: <InputAdornment position='start'>¥</InputAdornment>,
                    }}
                    variant="outlined"
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('add')}</Button>
            </DialogActions>
        </Box>
    );
};

export default TopUpCreationDialog;
